module.exports = __webpack_public_path__ + "static/media/ic-baggage.197976f6.svg";